module.exports = __webpack_public_path__ + "static/absence-356ca60bf133feea2e4b10b1ce0d6124.png";